import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { WizardService } from '../../../services/wizard/wizard.service';
import { BaseComponent } from '../../base/base.component';

@Component({
    selector: 'wizard-url-list',
    templateUrl: './url-list.component.html',
    styleUrls: ['../../form-styles.scss', './url-list.component.css']
})
export class UrlListComponent extends BaseComponent implements OnInit {
    private resultsSubscription: Subscription;
    public results: any[];
    public headerTitle = '';
    public providers = [''];
    public isEmptyState = true;
    public MAP = {
        'google drive': 'googledrive.png',
        apple: 'icloud.jpg',
        'G-Suite': 'google.png',
        hubspot: 'hubspot.svg',
        copper: 'copper.jpeg',
        drift: 'drift.svg',
        dropbox: 'dropbox.jpeg',
        gotomeeting: 'gotomeeting.jpeg',
        intercom: 'intercom.svg',
        mailchimp: 'mailchimp.svg',
        slack: 'slack.svg'
    };

    constructor(public wizardService: WizardService) {
        super();
    }

    ngOnInit() {
        this.initResults(null);
        this.initSubscription();
    }

    ngOnDestroy() {
        this.resultsSubscription.unsubscribe();
    }

    private initSubscription() {
        this.resultsSubscription = this.wizardService.responseData$.subscribe((response: any) => {
            if (response) {
                this.initResults(response);
            }
        });
    }

    private initResults(response) {
        if (!response) {
            return;
        }
        this.isEmptyState = false;
        this.results = response.results;
        this.headerTitle = response.headerTitle;
        this.providers = response.providers;
    }

    public clearResults() {
        this.isEmptyState = true;
        this.results = [];
        this.providers = [];
    }
}
